var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatCodei = function SvgChatCodei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.405 16.496a.46.46 0 0 1-.372-.541l1.349-8.072a.433.433 0 0 1 .519-.377.46.46 0 0 1 .372.529l-1.354 8.066a.45.45 0 0 1-.435.395zm2.5-2.088a.52.52 0 0 1 .091-.693l2.081-1.734-2.092-1.711a.517.517 0 0 1-.091-.693.435.435 0 0 1 .632-.1l2.572 2.115a.58.58 0 0 1 .191.385.52.52 0 0 1-.181.395l-2.572 2.131a.4.4 0 0 1-.27.1.45.45 0 0 1-.366-.191zm-4.15.113-2.572-2.129a.52.52 0 0 1-.181-.4.51.51 0 0 1 .192-.408l2.572-2.1a.44.44 0 0 1 .631.1.53.53 0 0 1-.1.693l-2.1 1.721 2.1 1.725a.535.535 0 0 1 .091.693.44.44 0 0 1-.361.2.46.46 0 0 1-.274-.091z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatCodei);
export default ForwardRef;